import { render, staticRenderFns } from "./addShopping.vue?vue&type=template&id=3d4bed3a&scoped=true&"
import script from "./addShopping.vue?vue&type=script&lang=js&"
export * from "./addShopping.vue?vue&type=script&lang=js&"
import style0 from "./addShopping.vue?vue&type=style&index=0&id=3d4bed3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4bed3a",
  null
  
)

export default component.exports